import { render } from "./AccountAddressFieldset.vue?vue&type=template&id=0cc897fa&scoped=true"
import script from "./AccountAddressFieldset.vue?vue&type=script&lang=js"
export * from "./AccountAddressFieldset.vue?vue&type=script&lang=js"

import "./AccountAddressFieldset.vue?vue&type=style&index=0&id=0cc897fa&scoped=true&lang=css"

import exportComponent from "/var/www/html/vg.carvex.ee/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cc897fa"]])

export default __exports__